// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import IconClose from "@conklin/XDL/Icons/IconClose";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xBaseTheme } from "@conklin/XDL/types";
import { color } from "@conklin/XDL/Utilities";
import { ButtonWrapper } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        color: "common.ui9",
        typographyProps: {
            size: 12,
            color: "common.white",
            weight: fontConfig.weight.bold,
            css: css`
                letter-spacing: 0;
                line-height: 15px;
                margin: 0;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            `,
        },
        iconProps: {
            size: 8,
            src: IconClose,
            color: "common.ui1",
        },
        css: css`
            border-radius: 13px;
            padding: 5px 8px;
            min-height: initial;
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            margin-bottom: 0;
            flex-direction: reverse;
            line-height: 1;
            &&& > ${ButtonWrapper} {
                margin-top: 4px;
                margin-left: 8px;
                min-height: initial;
                background: transparent;
                &:hover > ${IconWrapper} {
                    color: ${color("common.ui1")};
                }
            }
        `,
    },
} as xBaseTheme["tag"];
